import { render, staticRenderFns } from "./CoozzyAtIcon.vue?vue&type=template&id=1a091b10&scoped=true"
import script from "./CoozzyAtIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyAtIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyAtIcon.vue?vue&type=style&index=0&id=1a091b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a091b10",
  null
  
)

export default component.exports